<!-- @format -->
<template>
    <p>{{ $t('description') }}</p>
</template>
<script>
export default {
    name: 'BookingContentStatusPending',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking.theManageBooking.bookingContent.pending',
    },
};
</script>
